import ApiService from '@/common/ApiService/ApiService';
import { HttpVerb } from '@/common/ApiService/HttpVerb';
import { SearchResultsListViewModel } from '@/components/SearchResultsList/SearchResultsList.types';
import SearchPreviewCardViewModel from '@/components/SearchPreviewCard/SearchPreviewCard.types';

const searchApiService = new ApiService('/api/SearchApi/', {
  showLoading: false,
  cancel: true,
  returnData: true,
});

export const SearchHints = async (
  SearchString: string,
  showLoading: boolean,
  Category: number = 0,
): Promise<Array<SearchPreviewCardViewModel>> => {
  var result = await searchApiService.call(
    `SearchHints`,
    { SearchString: SearchString, PageCategory: Category },
    {
      showLoading,
      verb: HttpVerb.GET,
    },
  );

  return result.Item?.Results;
};

const SegmentAnalyticsService = new ApiService('/api/SegmentAnalytics/', {
  showLoading: false,
  cancel: true,
  returnData: true,
});

export interface SearchSegmentModel {
  url: string,
  brand: string,
  categories: Array<any>,
  currency: string,
  name: string,
  price: number,
  product_id: string,
}

export const SearchSegment = async (SearchUrls: string[]): Promise<Array<SearchSegmentModel>> => {
  var result = await SegmentAnalyticsService.call(`ItinerariesAnalytic`, SearchUrls, { verb: HttpVerb.POST });
  return result;
};